import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const languageProgramsManagement = createApi({
    reducerPath: "languageProgramsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        programList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/language-programs`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewProgram: builder.mutation({
            query: (programId) => ({
                url: `v1/${locale}/settings/language-programs/${programId}`,
                method: "GET",
            }),
        }),
        addProgram: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/language-programs`,
                method: "POST",
                body: body,
            }),
        }),
        updateProgram: builder.mutation({
            query: ({ body, programId }) => ({
                url: `v1/${locale}/settings/language-programs/${programId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteProgram: builder.mutation({
            query: (programId) => ({
                url: `v1/${locale}/settings/language-programs/${programId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { useProgramListMutation, useViewProgramMutation, useAddProgramMutation, useUpdateProgramMutation, useDeleteProgramMutation } =
    languageProgramsManagement;
